import React, { useEffect, useMemo, useState } from "react";
import { SelectOption } from "../../input/SearchInput/types";
import { SearchInput } from "../../input/SearchInput/SearchInput";
import { INDUSTRY_MESSAGES } from "./constants";
import { HgIndustry } from "../../../types/taxonomy";
import { useTaxonomyContext } from "../../../contexts/Taxonomy/TaxonomyContext";

interface HgIndustryInputProps {
  onIndustriesSelect: (industryIds: number[]) => void;
  selectedItems: number[];
  id?: string;
}

const convertToHgIndustryOptions = (data: HgIndustry[]): SelectOption[] => {
  return data.map((industry) => ({
    label: industry.name || "",
    value: industry.id?.toString() || "",
  }));
};

export const HgIndustryInput: React.FC<HgIndustryInputProps> = ({
  onIndustriesSelect,
  selectedItems = [],
  id = "hg-industries",
}) => {
  const [selectedOptions, setSelectedOptions] = useState<SelectOption[]>([]);
  const { hgIndustries } = useTaxonomyContext();

  const allOptions = useMemo(
    () => convertToHgIndustryOptions((hgIndustries || []) as HgIndustry[]),
    [hgIndustries]
  );

  useEffect(() => {
    if (allOptions.length > 0) {
      const initialSelectedOptions = allOptions.filter((option) =>
        selectedItems.includes(Number(option.value))
      );
      setSelectedOptions(initialSelectedOptions);
    }
  }, [selectedItems, allOptions]);

  const handleOptionsSelect = (options: SelectOption[]) => {
    setSelectedOptions(options);
    onIndustriesSelect(options.map((option) => Number(option.value)));
  };

  return (
    <SearchInput
      id={id}
      options={allOptions}
      selectedOptions={selectedOptions}
      onOptionsSelect={handleOptionsSelect}
      placeholderText={INDUSTRY_MESSAGES.PLACEHOLDER}
      noResultsMessage={INDUSTRY_MESSAGES.NO_RESULTS}
      minFilterLength={1}
    />
  );
};
